function updateCardLinksWithVariant(card, variantId) {
  if (!variantId) return;

  const links = card.querySelectorAll('a.link-redirect-to-product');

  links.forEach((link) => {
    if (link.href.includes(card.dataset.productUrl)) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    }
  });
}

function initSwatches(scope = document) {
  scope.querySelectorAll('.swatches').forEach((wrapper) => {
    const swatches = wrapper.querySelectorAll('.swatch');
    if (!swatches) return;
    const card = wrapper.closest('.card-wrapper');
    const mainImage = card.querySelector('.media img.main-image');
    const hoverImage = card.querySelector('.media img.hover-image');

    const selected = wrapper.querySelector('.swatch.selected');
    if (selected?.dataset.variantId) {
      updateCardLinksWithVariant(card, selected.dataset.variantId);
    }

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const variantId = swatch.dataset.variantId;
        updateCardLinksWithVariant(card, variantId);

        swatches.forEach((s) => s.classList.remove('selected'));
        swatch.classList.add('selected');

        const mainSrc = swatch.dataset.variantImage;
        const hoverSrc = swatch.dataset.variantHover;

        if (mainSrc && mainImage) {
          mainImage.src = mainSrc;
          mainImage.srcset = `
              ${mainSrc.replace(/width=\d+/, 'width=165')} 165w,
              ${mainSrc.replace(/width=\d+/, 'width=360')} 360w,
              ${mainSrc.replace(/width=\d+/, 'width=533')} 533w,
              ${mainSrc.replace(/width=\d+/, 'width=720')} 720w,
              ${mainSrc.replace(/width=\d+/, 'width=940')} 940w,
              ${mainSrc.replace(/width=\d+/, 'width=1066')} 1066w
            `;
        }

        if (hoverSrc && hoverImage) {
          hoverImage.src = hoverSrc;
          hoverImage.srcset = `
              ${hoverSrc.replace(/width=\d+/, 'width=165')} 165w,
              ${hoverSrc.replace(/width=\d+/, 'width=360')} 360w,
              ${hoverSrc.replace(/width=\d+/, 'width=533')} 533w,
              ${hoverSrc.replace(/width=\d+/, 'width=720')} 720w,
              ${hoverSrc.replace(/width=\d+/, 'width=940')} 940w,
              ${hoverSrc.replace(/width=\d+/, 'width=1066')} 1066w
            `;
          hoverImage.style.display = '';
        } else if (hoverImage) {
          hoverImage.removeAttribute('src');
          hoverImage.removeAttribute('srcset');
          hoverImage.style.display = 'none';
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSwatches();
});
